var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedbackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 71.52 71.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;stroke:#fff;}.cls-1,.cls-2{stroke-width:0.5px;}.cls-2{fill:#d68828;stroke:#d68828;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2206",
    "data-name": "Group 2206"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    className: "cls-1",
    d: "M24,59.78a2.92,2.92,0,0,1-1.05-.2,2.72,2.72,0,0,1-1.67-2.51V50.24h-7.3a2.71,2.71,0,0,1-2.71-2.71V18.88a2.71,2.71,0,0,1,2.71-2.71H55.31A2.71,2.71,0,0,1,58,18.88V47.53a2.72,2.72,0,0,1-2.72,2.71H35.08L25.85,59A2.62,2.62,0,0,1,24,59.78Zm-10-41.37a.47.47,0,0,0-.47.47h0V47.53a.47.47,0,0,0,.47.46h8.42a1.14,1.14,0,0,1,1.14,1.14v7.94a.47.47,0,0,0,.79.33l9.57-9.1a1.1,1.1,0,0,1,.76-.31H55.31a.47.47,0,0,0,.46-.47h0V18.88a.47.47,0,0,0-.46-.47H13.94Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    className: "cls-2",
    d: "M47.36,31.14H22.15a1.13,1.13,0,1,1-.32-2.24.86.86,0,0,1,.32,0H47.36a1.13,1.13,0,0,1,0,2.24Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    className: "cls-2",
    d: "M41.24,37.51H22.15a1.14,1.14,0,0,1-1.29-1,1.15,1.15,0,0,1,1-1.29H41.24a1.15,1.15,0,0,1,1.29,1,1.14,1.14,0,0,1-1,1.28A1.71,1.71,0,0,1,41.24,37.51Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackIcon);
export default __webpack_public_path__ + "static/media/feedback-icon.95688794146cb7750b9df841255ed0c4.svg";
export { ForwardRef as ReactComponent };